import type { ISelectItem, IItemWithStatus } from '~/types/models'
import { assertIsNumber } from '~/types/models'

/**
 * Items per status. `weightOf` makes each item count for more than one: the
 * msService roll-ups pass `getCountableMSServiceQuantity`, so the counts add up
 * to # Srvs. Contracts and service orders count one each.
 */
export function countUniqueStatii<T extends IItemWithStatus>(
  itemsWithStatus: T[],
  weightOf: (item: T) => number = () => 1
): {
  status: ISelectItem
  count: number
}[] {
  const map = Map.groupBy(itemsWithStatus, (item) => item.status.id)
  const countsList = [...map.values()].map((items) => ({
    status: items[0].status,
    count: items.reduce((sum, item) => sum + weightOf(item), 0),
  }))
  return countsList.sort(_sortCountsListItemsByStatusId)
}
function _sortCountsListItemsByStatusId(
  a: {
    status: ISelectItem
    count: number
  },
  b: {
    status: ISelectItem
    count: number
  }
) {
  assertIsNumber(a.status.id)
  assertIsNumber(b.status.id)
  return a.status.id - b.status.id
}
